import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { RadioButtonShared } from '../shared/radio-button-shared';
import { Subscription } from 'rxjs';
import { GenerateShared } from '../shared/generate-shared';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
})
export class RadioButtonComponent implements OnInit, OnDestroy {
  @Input() config: RadioButtonInputModel;

  element: any;
  isActive = false;

  subscription: Subscription;

  constructor(
    private radioButtonShared: RadioButtonShared,
    private generateShared: GenerateShared
  ) {
    this.subscription = this.radioButtonShared.radioButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked) {
          let array = [];
          if (this.config.type === 'disease') {
            array = this.generateShared.getDiseases();
          } else if (this.config.type === 'hatedFood') {
            array = this.generateShared.getHatedFoods();
          } else if (this.config.type === 'fastingDays') {
            array = this.generateShared.getFastingDays();
          }
          if (array.includes(this.config.title) && !this.isActive) {
            this.isActive = true;
            let bar =
              this.element.srcElement.id === 'radio-button'
                ? this.element.srcElement
                : this.element.srcElement.parentElement;
            bar.style.width = 'calc( 100% - 32px )';
            bar.style.right = '4px';
            setTimeout(() => {
              bar.style.width = 'calc( 100% - 24px )';
              bar.style.right = '0';
            }, 100);
          } else if (!array.includes(this.config.title) && this.isActive) {
            this.isActive = false;
            let bar =
              this.element.srcElement.id === 'radio-button'
                ? this.element.srcElement
                : this.element.srcElement.parentElement;
            bar.style.width = 'calc( 100% - 32px )';
            bar.style.right = '4px';
            setTimeout(() => {
              bar.style.width = 'calc( 100% - 24px )';
              bar.style.right = '0';
            }, 100);
          }
        }
      }
    );
  }

  ngOnInit() {
    let array = [];
    if (this.config.type === 'disease') {
      array = this.generateShared.getDiseases();
    } else if (this.config.type === 'hatedFood') {
      array = this.generateShared.getHatedFoods();
    } else if (this.config.type === 'fastingDays') {
      array = this.generateShared.getFastingDays();
    }
    if (array.includes(this.config.title) && !this.isActive) {
      this.isActive = true;
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  clicked(e) {
    this.element = e;
    this.radioButtonShared.radioButtonClicked(
      this.config.title,
      this.config.type
    );
  }
}

export interface RadioButtonInputModel {
  title: string;
  id: number;
  type: string;
}
